export default {
  setGoodOrders(state, payload) {
    state.goodOrders = payload
  },
  updateGoodOrders(state, payload) {
    state.goodOrders = state.goodOrders.concat(payload)
  },
  setGoodOrderFilters(state, payload) {
    state.goodOrderFilters = payload
  },
  setGoodOrderStatuses(state, payload) {
    state.goodOrderStatuses = payload
  },
  setGoodOrder(state, payload) {
    state.goodOrder = payload
  },
  addGoodOrder(state, payload) {
    state.goodOrders.unshift(payload)
  },
  changeGoodOrder(state, payload) {
    for (let i = 0; i < state.goodOrders.length; i++) {
      if (state.goodOrders[i].id === payload.id) {
        state.goodOrders.splice(i, 1, payload)
        break
      }
    }
  },
  setGoodOrderField(state, obj) {
    if (state.goodOrder) {
      state.goodOrder = { ...state.goodOrder, ...obj }
    }
  },
  deleteGoodOrder(state, id) {
    for (let i = 0; i < state.goodOrders.length; i++) {
      if (state.goodOrders[i].id === id) {
        state.goodOrders.splice(i, 1)
        break
      }
    }
  },
  setGoodOrderItems(state, payload) {
    state.goodOrderItems = payload
  },
  changeGoodOrderItem(state, payload) {
    for (let i = 0; i < state.goodOrderItems.length; i++) {
      if (state.goodOrderItems[i].id === payload.id) {
        state.goodOrderItems.splice(i, 1, payload)
        break
      }
    }
  },
  addGoodOrderItem(state, payload) {
    state.goodOrderItems.unshift(payload)
  },
  deleteGoodOrderItem(state, id) {
    for (let i = 0; i < state.goodOrderItems.length; i++) {
      if (state.goodOrderItems[i].id === id) {
        state.goodOrderItems.splice(i, 1)
        break
      }
    }
  },
  setGoodOrderProducts(state, payload) {
    state.goodOrderProducts = payload
  },
  setSyncItems(state, payload) {
    state.syncItems = payload
  },
}
